/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpPolicySetModule
 */

import { MessageItem }
    from 'ajs/modules/data-model/factories/message-item.factory';
import { RepeatedMessageItem }
    from 'ajs/modules/data-model/factories/repeated-message-item.factory';

import {
    withEditChildMessageItemMixin,
} from 'ajs/modules/data-model/mixins/with-edit-child-message-item.mixin';

import { IHTTPRequestPolicy } from 'generated-types';
import { HTTPRequestPolicy } from 'object-types';
import { HTTPRequestRuleConfigItem } from './http-request-rule.config-item.factory';

type THTTPRequestPolicyPartial = Omit<IHTTPRequestPolicy, 'rules'>;

interface IHTTPRequestPolicyConfig extends THTTPRequestPolicyPartial {
    rules?: RepeatedMessageItem<HTTPRequestRuleConfigItem>;
}

/**
 * @description
 *
 *   HTTPPolicySet Request Policy Message Item.
 *
 * @author Abhinesh Gour, Umesh Chovatiya
 */
export class HTTPRequestPolicyConfigItem extends
    withEditChildMessageItemMixin(MessageItem)<IHTTPRequestPolicyConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HTTPRequestPolicy,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Opens Create HTTP Request Rule Modal.
     */
    public addRequestRule(): void {
        this.addChildMessageItem({
            field: 'rules',
            modalBindings: {
                isEditing: false,
            },
        });
    }

    /**
     * Getter for HTTP Request Rule ConfigItem.
     */
    public get rules(): RepeatedMessageItem<HTTPRequestRuleConfigItem> {
        return this.config.rules;
    }

    /**
     * Merge match field as null if match does not exist in Request item for edit.
     */
    public editRequestRuleModal(messageItem: HTTPRequestRuleConfigItem): void {
        if (!messageItem.config.match) {
            messageItem.mergeConfig({ match: null });
        }

        this.editChildMessageItem({
            field: 'rules',
            messageItem,
            modalBindings: {
                isEditing: true,
            },
        });
    }
}
